export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    message: undefined as string | undefined,
    type: undefined as 'warning' | 'error' | 'info' | 'success' | null | undefined
  }),
  actions: {
    showSnackbar({
      message,
      type
    }: {
      message: string;
      type: 'warning' | 'error' | 'info' | 'success' | null | undefined;
    }) {
      this.message = message;
      this.type = type;

      // Automatically clear the snackbar after a delay (optional)
      setTimeout(() => {
        this.message = undefined;
        this.type = undefined;
      }, 3000);
    }
  }
});
